import React from "react";

import TopBarLogo from "./TopBarLogo";

import styles from "./topbar.module.scss";
import { useSelector } from "react-redux";
import { UserState } from "redux-oidc";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import TopBarHeading from "./TopBarHeading";
import IAppState from "infrastructure/store/IAppState";
import DeviceTypeEnum from "features/shared/enums/DeviceTypeEnum";
import LanguageDropdown from "./LanguageDropdown";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import { isMultipleLangs } from "features/shared/helpers/languageHelper";
import { useTranslation } from "react-i18next";

const TopBarSimple = () => {
	// tanslations
  const tLabels = useTranslation("shared\\components").t;

  // store
  const user = useSelector<IAppState, UserState>((store) => store.oidc).user;

  // helpers
  const showActionsBar = () => {
    return isLoggedUser() || isMultipleLangs();
  };

	const isLoggedUser = () => { 
		return user !== null;
	}

  // sub-renders
  const renderUserInfo = () => {
    if (isLoggedUser()) {
      return (
        <div className={`order-md-1 mr-auto mr-0 ${styles.topbarProfileItem}`}>
          <span className={`mr-2 ${styles.topbarProfileAvatar}`}>
            <FontAwesomeIcon icon="user" />
          </span>
          <span
            className={`d-inline-block text-truncate ${styles.topbarProfileText}`}
          >
            {user?.profile.email}
          </span>
        </div>
      );
    }
  };

  const renderLogoutBtn = () => {
    if (isLoggedUser()) {
      return (
        <div className={`order-md-2 ${styles.topbarActionItem}`}>
          <Link to="/logout" className={styles.topbarActionBtn}>
            <FontAwesomeIcon icon="sign-out-alt" />
          </Link>
        </div>
      );
    }
  };

  const renderLogoOnMobile = () => {
    if (!isLoggedUser()) {
			const wrapperClass = isMultipleLangs() ? "col-auto px-0" : "col px-0 mx-auto mx-md-0";

      return (
        <div className={`d-md-none ${styles.topBarLogoWrapper} ${wrapperClass}`}>
          <TopBarLogo type={DeviceTypeEnum.MOBILE} />
        </div>
      );
    }
  };

	const renderTopBarHeading = () => { 
		if (tLabels("topBarHeading.heading") !== "") {
			let wrapperClass = isMultipleLangs() || isLoggedUser() ? "d-none d-sm-block col-auto px-0" : "col px-0";

			return (
				<div className={wrapperClass}>
					<div className="d-flex align-items-center h-100">
						<TopBarHeading />
					</div>
				</div>
			)
		}
	}

  // render
  return (
    <nav className={`navbar navbar-expand ${styles.topbar}`}>
      <div className={styles.topbarContainer}>
        {renderLogoOnMobile()}
        <TopBarLogo type={DeviceTypeEnum.DESKTOP} />
        {renderTopBarHeading()}
        <RenderWrapper isVisible={showActionsBar}>
          <div
            className={`d-flex justify-content-end ml-md-auto ${styles.topbarActionsBar}`}
          >
            {renderUserInfo()}
            <LanguageDropdown />
            {renderLogoutBtn()}
          </div>
        </RenderWrapper>
      </div>
    </nav>
  );
};

export default TopBarSimple;
